import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createCarColorByAdmin($name: String!, $code: String!) {
    createCarColorByAdmin(input: { name: $name, code: $code }) {
      _id
      code
      name
    }
  }
`;

const GET = gql`
  query getCarColors($limit: Int, $skip: Int) {
    getCarColors(pagination: { limit: $limit, skip: $skip }) {
      _id
      code
      name
    }
  }
`;

const COUNT = gql`
  query getCarColorsCount {
    getCarColorsCount
  }
`;

const UPDATE = gql`
  mutation updateCarColorByAdmin($id: ID!, $name: String!, $code: String!) {
    updateCarColorByAdmin(id: $id, input: { name: $name, code: $code }) {
      _id
      name
      code
    }
  }
`;

const DELETE = gql`
  mutation deleteCarColorByAdmin($idSet: [ID!]!) {
    deleteCarColorByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const IMPORT = gql`
  mutation addCarColorViaExcel($excelFile: Upload!) {
    addCarColorViaExcel(excelFile: $excelFile)
  }
`;

/**
 * Colors - the paint colours a driver can pick for their vehicle.
 *
 * The colour code was a plain text box, so nobody adding one could see
 * what they were adding; it now has a swatch and a picker beside it.
 */
const Colors = () => (
  <SettingsList
    title="Colours"
    description="The paint colours drivers pick from when registering a vehicle."
    singular="colour"
    list={{ query: GET, key: "getCarColors" }}
    count={{ query: COUNT, key: "getCarColorsCount" }}
    create={{
      mutation: ADD,
      variables: (values) => ({ name: values.name.trim(), code: values.code.trim() }),
    }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({
        id: row._id,
        name: values.name.trim(),
        code: values.code.trim(),
      }),
    }}
    remove={{ mutation: DELETE }}
    importExcel={{
      mutation: IMPORT,
      templateRows: [
        ["Name", "Code"],
        ["Black", "#000000"],
        ["Silver", "#c0c0c0"],
      ],
      fileName: "Spark-Colours-Template.xlsx",
    }}
    columns={[
      { key: "name", label: "Colour", width: "2fr" },
      {
        key: "code",
        label: "Code",
        width: "2fr",
        render: (row) => (
          <span className="settingsSwatch">
            <span className="settingsSwatchChip" style={{ background: row.code }} />
            {row.code}
          </span>
        ),
      },
    ]}
    fields={[
      { name: "name", label: "Colour", type: "text", required: true },
      {
        name: "code",
        label: "Code",
        type: "color",
        required: true,
        defaultValue: "#000000",
        hint: "The swatch drivers see in the app.",
      },
    ]}
    toValues={(row) => ({ name: row.name, code: row.code })}
  />
);

export default Colors;
